import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Search, Plus, Trash2 } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";

const PaymentTitle = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  // Get Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://api.havirkesht.ir/payment-reason/?sort_by=updated_at&sort_order=desc"
        );
        const items = res?.data?.items || [];
        setData(items);
        setload(items.length < 0);
      } catch (error: any) {
        console.error("Error fetching data:", error);
        if (error) {
          setErrorMessage(
            "مشکلی در ارتباط با سرور رخ داده است. لطفاً اینترنت خود را بررسی کنید و مطمئن شوید فیلترشکن غیرفعال است."
          );
        } else {
          setErrorMessage("خطایی رخ داده است. لطفاً مجدداً تلاش کنید.");
        }
        setload(true);
      }
    };
    fetchData();
  }, [reload]);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.reason_name) {
      setEventData(cell.reason_name);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      const res = await axios.delete(
        `https://api.havirkesht.ir/payment-reason/${eventData}`
      );
      if (res.status === 200) {
        toast.success("عملیات حذف با موفقیت انجام شد");
        setreload(!reload);
      } else {
        toast.error("خطا ای رخ داده لطفا مجدد تلاش کنید");
      }
      setDeleteModal(false);
      setEventData(null);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      reason_name: "",
    },
    validationSchema: Yup.object({
      reason_name: Yup.string().required("لطفاً پرداخت را انتخاب کنید"),
    }),
    onSubmit: async (values) => {
      setload(true);
      const res = await axios.post(
        "https://api.havirkesht.ir/payment-reason/",
        values
      );
      if (res.status === 201) {
        toast.success(`پرداخت جدید ثبت شد`);
        setreload(!reload);
        setload(false);
      } else {
        setload(false);
        toast.error(`خطا در ثبت`);
      }
      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const columns = useMemo(
    () => [
      {
        header: "عنوان",
        accessorKey: "reason_name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "تاریخ ایجاد",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link to="#" onClick={() => onClickDelete(cell.row.original)}>
              <Trash2 className="size-4" />
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت پرداخت" title="هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      {errorMessage && <div>{errorMessage}</div>}
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex items-center gap-3 mb-4">
            <h6 className="text-15 grow">
              مجموع پرداخت ها (<b className="total-Employs">{data?.length}</b>)
            </h6>
            <div className="shrink-0">
              <Link
                to="#"
                onClick={toggle}
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl">ایجاد پرداخت جدید</span>{" "}
                <Plus className="inline-block size-4 rtl" />
              </Link>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={true}
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
        </div>
      </div>

      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16"> ایجاد پرداخت جدید </Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-11 dark:text-white text-gray-800">
                <div className="flex items-center">
                  <label
                    htmlFor="reason_name"
                    className="text-base font-medium mr-2 w-1/3"
                  >
                    عنوان پرداخت:
                  </label>
                  <input
                    type="text"
                    id="reason_name"
                    className="form-input text-black font-[12px] "
                    placeholder="عنوان پرداخت"
                    name="reason_name"
                    autoComplete="off"
                    onChange={validation.handleChange}
                    value={validation.values.reason_name}
                  />
                </div>
                {validation.touched.reason_name &&
                  validation.errors.reason_name && (
                    <p className="text-red-400 mr-24 mt-2">
                      {validation.errors.reason_name}
                    </p>
                  )}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button"
            disabled={load}
            onClick={handleClick}
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            {load ? "در حال ارسال..." : "    ثبت اطلاعات"}
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default PaymentTitle;
